import { render } from "./LoadPreviewer.vue?vue&type=template&id=3c53cd73&scoped=true"
import script from "./LoadPreviewer.vue?vue&type=script&lang=js"
export * from "./LoadPreviewer.vue?vue&type=script&lang=js"

import "./LoadPreviewer.vue?vue&type=style&index=0&id=3c53cd73&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c53cd73"]])

export default __exports__